@if (condition.isNew) {
  <cal-add-currency-adjustment-condition-variant [condition]="condition">
  </cal-add-currency-adjustment-condition-variant>
}
<div class="panel" style="margin-top: 5px;">
  <div class="panel-body">
    <cal-calsiumlist-listing [config]="listConfig" [ListBodyData]="dataList | async" [isLoading]="isLoading | async"
      [dataTotalCount]="(dataList | async).length">
    </cal-calsiumlist-listing>
  </div>
</div>